import {
  UserForSearch,
  User,
  AccountDropdownDto,
  ProjectSearchDto,
  AccountSearchItem,
  ProjectSearchItem,
  SearchItem,
} from '../../types';
import { useMemo } from 'react';
import { separators } from '../../constants';

export function useMapUsersForSearch(options: User[]): UserForSearch[] {
  return useMemo((): UserForSearch[] => {
    return (options || []).map((option): UserForSearch => {
      const { fullName } = option;

      const names = (fullName || '').split(separators.space);

      return {
        ...option,
        names,
      };
    });
  }, [options]);
}

export function useSearchItems(
  users: User[],
  accounts: AccountDropdownDto[],
  projects: ProjectSearchDto[],
): SearchItem[] {
  const userItems = useMapUsersForSearch(users);

  return useMemo((): SearchItem[] => {
    const accountItems: AccountSearchItem[] = (accounts || []).map((a) => ({
      kind: 'account',
      id: a.id,
      name: a.name,
      names: [a.name],
    }));

    const projectItems: ProjectSearchItem[] = (projects || []).map((p) => ({
      kind: 'project',
      id: p.id,
      name: p.name,
      accountId: p.accountId,
      names: [p.name],
    }));

    return [...userItems, ...accountItems, ...projectItems];
  }, [userItems, accounts, projects]);
}
